// Angular
import { Injectable } from '@angular/core';

// Third party
import { Observable } from 'rxjs';

// Local library
import { IGetResultRequest, IToteResultResponse } from '@amwager/util-ts';

// Local file
import { HttpService } from '../services';



// TODO: write tests
@Injectable()
export class ToteResultAPIService {
  private readonly API_URL = '/api/ToteResult';

  constructor(
    private readonly httpService: HttpService,
  ) {}


  /**
   * GET API
   */

  /**
   * @description
   * Get results for a specific race by date.
   * Notes: requested date format should be MM-dd-yyyy e.g 07-29-2016
   *
   * @param requests IGetResultByDateRequest & { raceDateStr: string }
   * @returns Observable<IToteResultResponse>
   */
  getResultByDate$(requests: IGetResultRequest & { raceDateStr: string })
    : Observable<IToteResultResponse> {
    return this.httpService.get$({
      api: `${this.API_URL}/GetResultByDaye`,
      params: this.httpService.objToHttpParams(requests as unknown as Record<string, unknown>)
    });
  }

  /**
   * @description
   * Get results of a specific race by RunId
   *
   * @param requests IGetResultByDateRequest & { runId: string }
   * @returns Observable<IToteResultResponse>
   */
  getResult$(requests: IGetResultRequest & { runId: string })
    : Observable<IToteResultResponse> {
    return this.httpService.get$({
      api: `${this.API_URL}/GetResult`,
      params: this.httpService.objToHttpParams({
        runId: requests.runId,
        raceId: requests.raceId,
        eventId: requests.eventId,
        getPoolTotals: requests.getPoolTotals
      })
    });
  }

}
